module.exports = __webpack_public_path__ + "static/media/IMG_0774-cut-crop-reducedres.f2146475.jpg";